import React from 'react';
import { Box, Chip, Paper, Slider, Stack, Typography } from '@mui/material';

const MARKS = [
  { value: 0, label: 'Nicht getestet' },
  ...[1, 2, 3, 4, 5, 6].map((value) => ({ value, label: String(value) })),
];

export default function FullDuplexScoreField({ criterion, value, disabled, onChange }) {
  const sliderValue = value == null ? 0 : Number(value);
  return (
    <Paper variant="outlined" sx={{ p: 2, borderRadius: 2, height: '100%', minHeight: 160 }}>
      <Stack spacing={1.5}>
        <Stack direction="row" spacing={1} justifyContent="space-between" alignItems="flex-start">
          <Typography variant="body2" sx={{ fontWeight: 700 }}>{criterion.label}</Typography>
          <Chip
            size="small"
            color={sliderValue === 0 ? 'default' : (sliderValue <= 2 ? 'success' : sliderValue <= 4 ? 'warning' : 'error')}
            label={sliderValue === 0 ? 'Nicht getestet' : `Note ${sliderValue}`}
          />
        </Stack>
        <Box sx={{ px: { xs: 5, sm: 6 } }}>
          <Slider
            min={0}
            max={6}
            step={1}
            marks={MARKS}
            value={sliderValue}
            disabled={disabled}
            onChange={(_, score) => onChange(score === 0 ? null : score)}
            valueLabelDisplay="auto"
            valueLabelFormat={(score) => score === 0 ? 'Nicht getestet' : `Note ${score}`}
            aria-label={criterion.label}
            sx={{
              '& .MuiSlider-rail': {
                opacity: 1,
                background: 'linear-gradient(90deg, #90A4AE 0 14%, #2E7D32 20%, #8AA62F 38%, #E9B522 56%, #EF6C00 75%, #C62828 100%)',
              },
              '& .MuiSlider-track': { border: 0, bgcolor: 'transparent' },
            }}
          />
        </Box>
      </Stack>
    </Paper>
  );
}
